import { assertUnreachable, createVisitor } from '~libs.typescript';

import {
   AiAssistantRecordingGlobalState,
   PausedState,
   PendingState,
   RecordingState,
} from './shared/useAiAssistantRecordingGlobalState.types';

export const aiAssistantRecordingStateVisitor = createVisitor<
   AiAssistantRecordingGlobalState,
   {
      visitIdle: void;
      visitRecording: RecordingState;
      visitMobileRecording: void;
      visitPaused: PausedState;
      visitPending: PendingState;
      visitMobilePending: void;
      visitFinal: void;
   }
>((state, visitor) => {
   switch (state.type) {
      case 'idle':
         return visitor.visitIdle?.();
      case 'recording':
         return visitor.visitRecording?.(state);
      case 'mobileRecording':
         return visitor.visitMobileRecording?.();
      case 'paused':
         return visitor.visitPaused?.(state);
      case 'pending':
         return visitor.visitPending?.(state);
      case 'mobilePending':
         return visitor.visitMobilePending?.();
      case 'final':
         return visitor.visitFinal?.();
      default:
         return assertUnreachable(state);
   }
});
